import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const Splash = () => {
  const [phase, setPhase] = useState(0);
  const navigate = useNavigate();

  useEffect(() => {
    const t1 = setTimeout(() => setPhase(1), 400);
    const t2 = setTimeout(() => setPhase(2), 1200);
    const t3 = setTimeout(() => setPhase(3), 2000);
    const t4 = setTimeout(() => {
      const hasOnboarded = localStorage.getItem('vibe_onboarded');
      navigate(hasOnboarded ? '/login' : '/onboarding');
    }, 3200);
    return () => { clearTimeout(t1); clearTimeout(t2); clearTimeout(t3); clearTimeout(t4); };
  }, [navigate]);

  return (
    <div style={{
      height: '100vh', display: 'flex', flexDirection: 'column',
      alignItems: 'center', justifyContent: 'center',
      background: '#08080C', position: 'relative', overflow: 'hidden',
    }}>
      <div style={{
        position: 'absolute', top: '30%', left: '50%', transform: 'translate(-50%, -50%)',
        width: 300, height: 300, borderRadius: '50%',
        background: 'radial-gradient(circle, rgba(255,61,113,0.15) 0%, rgba(139,92,246,0.08) 50%, transparent 70%)',
        filter: 'blur(40px)',
        opacity: phase >= 1 ? 1 : 0,
        transition: 'opacity 1s ease',
      }} />
      <div style={{
        position: 'absolute', top: '40%', left: '40%', transform: 'translate(-50%, -50%)',
        width: 200, height: 200, borderRadius: '50%',
        background: 'radial-gradient(circle, rgba(139,92,246,0.12) 0%, transparent 70%)',
        filter: 'blur(30px)',
        opacity: phase >= 1 ? 1 : 0,
        transition: 'opacity 1.2s ease 0.3s',
      }} />

      <div style={{
        opacity: phase >= 1 ? 1 : 0, transform: phase >= 1 ? 'scale(1)' : 'scale(0.8)',
        transition: 'all 0.8s cubic-bezier(0.34, 1.56, 0.64, 1)',
        display: 'flex', flexDirection: 'column', alignItems: 'center', zIndex: 1,
      }}>
        <div style={{
          width: 88, height: 88, borderRadius: 28, marginBottom: 24,
          background: 'linear-gradient(135deg, #FF3D71, #8B5CF6)',
          display: 'flex', alignItems: 'center', justifyContent: 'center',
          boxShadow: '0 8px 40px rgba(255,61,113,0.4)',
          animation: phase >= 2 ? 'pulse 2s ease infinite' : 'none',
        }}>
          <svg width="44" height="44" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z" />
          </svg>
        </div>
        <h1 style={{
          fontSize: 48, fontWeight: 900, letterSpacing: '-0.03em',
          background: 'linear-gradient(135deg, #FFFFFF, #A1A1AA)',
          WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent',
        }}>VIBE</h1>
      </div>

      <p style={{
        position: 'absolute', bottom: 100,
        fontSize: 15, color: '#71717A', letterSpacing: '0.08em',
        opacity: phase >= 2 ? 1 : 0, transform: phase >= 2 ? 'translateY(0)' : 'translateY(10px)',
        transition: 'all 0.6s ease',
      }}>Find Your Real Connection</p>

      {phase >= 3 && (
        <div style={{
          position: 'absolute', bottom: 40,
          width: 28, height: 28, borderRadius: '50%',
          border: '2.5px solid rgba(255,255,255,0.1)',
          borderTopColor: '#FF3D71',
          animation: 'spin 0.8s linear infinite',
        }} />
      )}
    </div>
  );
};

export default Splash;
